// extracted by mini-css-extract-plugin
module.exports = {"notificationContainer":"_2_oyD","title":"_3f5YV","content":"_1yUnp","buttonContainer":"_8oY01"};